<template>
  <div id="blade5b">
    <video
      aria-label="“Man playing a game on his laptop computer as lights from the screen flash on his face"
      id="blade5b-video"
      preload="true"
      playsinline
      autoplay
      loop
      muted
    >
      <source src="../../assets/videos/Developer-Looping-Video.mp4" type="video/mp4" />
    </video>
  </div>
</template>

<script>
export default {
  name: "Blade5b"
};
</script>

<style lang="scss">
@import "@/assets/styles/blade5b.scss";
</style>